var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCalendarR = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 21,
  viewBox: "0 0 20 21",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M1 9.125H19M15 1.125V5.125M5 1.125V5.125M15 3.125H5C3.93913 3.125 2.92172 3.54643 2.17157 4.29657C1.42143 5.04672 1 6.06413 1 7.125V15.875C1 16.9359 1.42143 17.9533 2.17157 18.7034C2.92172 19.4536 3.93913 19.875 5 19.875H15C16.0609 19.875 17.0783 19.4536 17.8284 18.7034C18.5786 17.9533 19 16.9359 19 15.875V7.125C19 6.06413 18.5786 5.04672 17.8284 4.29657C17.0783 3.54643 16.0609 3.125 15 3.125Z",
  stroke: "#00BFFF",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgCalendarR);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/calendar-r.0ca6efdead8706617430c673b9fb7c60.svg";